import { render, staticRenderFns } from "./AdviserChannelPage.vue?vue&type=template&id=063bccf1&scoped=true"
import script from "./AdviserChannelPage.vue?vue&type=script&lang=js"
export * from "./AdviserChannelPage.vue?vue&type=script&lang=js"
import style0 from "./AdviserChannelPage.vue?vue&type=style&index=0&id=063bccf1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063bccf1",
  null
  
)

export default component.exports